import React from "react";
import { createRoot } from "react-dom/client";
import { autobind } from "lib/decorators";
import LuvitSkyLight from "lib/components/LuvitSkyLight";
import LuvitMovableSkyLight from "lib/components/LuvitMovableSkyLight";

const ESCAPE_KEY = 27;

export default class Modal extends React.Component {
  _handleKeyDown(event) {
    switch (event.keyCode) {
      case ESCAPE_KEY:
        this.hide();
        break;
      default:
        break;
    }
  }

  show() {
    this.refs.modal.show();
  }
  hide() {
    this.refs.modal.hide();
  }

  componentDidMount() {
    if (this.props.initiallyOpen) this.show();
  }

  componentWillMount() {
    document.addEventListener("keydown", this._handleKeyDown.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown.bind(this));
  }

  render() {
    return (
      <LuvitSkyLight autoFocus={true} {...this.props} ref="modal">
        {this.props.children}
      </LuvitSkyLight>
    );
  }
}

@autobind
class MovableModal extends React.Component {
  componentWillMount() {
    let { modalId, initiallyOpen } = this.props;
    if (!modalId) {
      modalId = `modal-${Date.now()}`;
    }

    const existingModal = document.getElementById(modalId);
    if (existingModal) {
      this.node = existingModal;
    } else {
      this.node = document.createElement("div");
      this.node.id = modalId;
      document.body.appendChild(this.node);
      this.setState({ open: initiallyOpen || false });
    }
    if (initiallyOpen) {
      this.show();
    }
    document.addEventListener("keydown", this._handleKeyDown.bind(this));
  }

  componentDidMount() {
    this.renderChildren(this.props.children);
  }

  componentWillReceiveProps(newProps) {
    this.renderChildren(newProps.children);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown.bind(this));

    try {
      const element = document.getElementById(this.props.modalId);

      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    } catch (ex) {
      console.log(ex);
    }
    this.hide();
  }

  _handleKeyDown(event) {
    switch (event.keyCode) {
      case ESCAPE_KEY:
        this.hide();
        break;
      default:
        break;
    }
  }

  onModalCreated(modal) {
    if (!modal) {
      this.modal = null;
      return;
    }
    this.modal = modal;
    if (this.state.open) modal.show();
  }

  show() {
    this.setState({ open: true });
    if (this.modal) this.modal.show();
  }

  hide() {
    this.setState({ open: false });
    if (this.modal) this.modal.hide();
  }

  renderChildren(children) {
    if (!this.node) return;
    if (!this.root) {
      this.root = createRoot(this.node);
    }
    this.wrapper = this.root.render(
      <LuvitMovableSkyLight
        autoFocus={true}
        {...this.props}
        ref={this.onModalCreated}
      >
        {children}
      </LuvitMovableSkyLight>,
    );
  }

  render() {
    return null; //this.renderChildren(this.props.children);
  }
}

Modal.Movable = MovableModal;
